import {Component, Input, OnDestroy, OnInit, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';
import { Field } from '../../interfaces/field';
import { UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { PaymentGateway } from '../../interfaces/payment-gateway';
import { StateService } from '../../services/state.service';

@Component({
    selector: 'app-payment-method-field',
    templateUrl: './payment-method-field.component.html',
    encapsulation: ViewEncapsulation.Emulated,
    styleUrls: ['./payment-method-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PaymentMethodFieldComponent implements OnInit, OnDestroy {
  @Input() config: Field;
  @Input() control: UntypedFormGroup;
  gateways: PaymentGateway[] = [];
  changes: Subscription;
  gatewaySub: Subscription;
  selected: string;
  _state: StateService;
  readonly svgIcons = new Set(['cash', 'ideal', 'payments', 'paypal', 'credit_card', 'stripe', 'square', 'wipay', 'multisafepay']);

  // The portal stores PrimeIcons names (`pi-*`); this component only knows the SVG set above
  // and Material ligatures, so translate them (an unknown `pi-*` name renders as blank).
  private readonly iconAliases: Record<string, string> = {
    'pi-money-bill': 'cash',
    'pi-credit-card': 'credit_card',
    'pi-link': 'link',
    'pi-receipt': 'receipt',
  };

  iconName(icon?: string): string {
    return (icon && this.iconAliases[icon]) || icon || '';
  }

  // mobile-popup widget: render as a selectbox that opens a dialog (set via the html theme class).
  open = false;

  constructor(private state: StateService) {
    this._state = state;
  }

  get isMobilePopup(): boolean {
    return typeof document !== 'undefined'
      && document.documentElement.classList.contains('wb-theme-mobilepopup');
  }

  get selectedGateway(): PaymentGateway | undefined {
    const value = this.control?.get(this.config.property)?.value;
    return this.gateways?.find(g => g.id === value);
  }

  selectGateway(id: string): void {
    this.control?.get(this.config.property)?.setValue(id);
    this.open = false;
  }
  ngOnInit() {
    this.gatewaySub = this.state.paymentGateways$.subscribe((gateways: PaymentGateway[]) => {
      this.gateways = gateways;
    });
    this.changes = this.control.controls[this.config.property].valueChanges.subscribe(value => {
      this.selected = value;
    });
  }

  ngOnDestroy(): void {
    if (this.gatewaySub) {
      this.gatewaySub.unsubscribe();
    }
    if (this.changes) {
      this.changes.unsubscribe();
    }
  }

}
